import DashboardI18n from './Dashboard/Dashboard.i18n.en';
import AttemptReport from './AttemptReport/AttemptReport.i18n.en';
import DpScoreProgressBar from './Components/ScoreProgressBar/DpScoreProgressBar.i18n.en';
export default {
  reports: {
    ...DashboardI18n,
    ...AttemptReport,
    ...DpScoreProgressBar
  }
};